import CreateFailure from './CreateFailure';

export default CreateFailure;
